module.exports = __webpack_public_path__ + "img/mingbai1.2_5725f059a.png";